import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/content";
export function FinalCta() {
  return <>
      <section className="w-full bg-brand px-5 py-16 sm:py-20" data-id="element-126" data-mp="vgqz8pox3ejm">
        <div className="mx-auto max-w-3xl text-center" data-id="element-127" data-mp="19f7fp8cl0jey">
          <p className="text-sm font-extrabold uppercase tracking-wider text-white/85" data-id="element-128" data-mp="19cur4ccbjasx">
            Ready to Bring More Structure to Your BCM Diagnostics?
          </p>
          <h2 className="mt-3 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-white sm:text-5xl" data-id="element-129" data-mp="1jbtw9kxvkob6">
            Stop Guessing How to Organize Your Investigation. Start Following a Clear Diagnostic Path.
          </h2>
          <img src={images.mainMockup} alt="BCM Diagnostic Blueprint complete collection" className="mx-auto mt-8 w-full max-w-xl" loading="lazy" data-id="element-130" data-mp="1t4rd7mn7y57o" />
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/90" data-id="element-131" data-mp="224o3fsp9bc4u">
            Get the six-volume collection, five practical bonuses, visual diagnostic workflows, decision frameworks,
            and case documentation tools — all for a one-time payment of <strong className="text-white" data-id="element-132" data-mp="s4fjdtilrt1i">$27</strong>.
          </p>
          <div className="mt-8" data-id="element-133" data-mp="s6s1q7s9w5f3">
            <CtaButton tone="dark" note="Instant Digital Access · One-Time Payment · Lifetime Access · 7-Day Money-Back Guarantee" data-id="element-134" data-mp="x420wf5grvg4">
              Yes! I Want the BCM Diagnostic Blueprint
            </CtaButton>
          </div>
        </div>
      </section>
      <footer className="w-full bg-navy-900 px-5 pb-32 pt-10 text-center" data-id="element-135" data-mp="1646vfopk6zcv">
        <p className="font-display text-lg font-black text-white" data-id="element-136" data-mp="1b28p13km2h2l">BCM Diagnostic Blueprint™</p>
        <p className="mt-1 text-sm text-white/70" data-id="element-137" data-mp="1fvb9mm7eug6n">Created by Jason Mitchell</p>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/60" data-id="element-138" data-mp="1ktw8oiaxetti">
          A practical framework for organizing Body Control Module diagnostic investigations.
        </p>
        <p className="mt-6 text-xs text-white/50" data-id="element-139" data-mp="1tu16c0qbiduh">© 2026 BCM Diagnostic Blueprint™. All rights reserved.</p>
      </footer>
    </>;
}